/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contact } from '../../models/contact';

export interface GetContactsByCase$Plain$Params {

/**
 * id of the case to which the contacts are associated
 */
  caseId: number;
}

export function getContactsByCase$Plain(http: HttpClient, rootUrl: string, params: GetContactsByCase$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Contact>>> {
  const rb = new RequestBuilder(rootUrl, getContactsByCase$Plain.PATH, 'get');
  if (params) {
    rb.path('caseId', params.caseId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Contact>>;
    })
  );
}

getContactsByCase$Plain.PATH = '/api/Case/{caseId}/Contacts';
